import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import RecordsPage from './RecordsPage';
import './RecordsPage.less';

export const prefix = 'bm-p-records';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: RecordsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
